<app-dynamic-grid
[gridConfig]="gridConfig"
[getDataUrl]="getDataUrl"
[sortBy]="'startTime'"
[sortOrder]="'desc'"
></app-dynamic-grid>
<app-toast></app-toast>
